export const userData = [
  {
    name: "Jan",
    "Active User": 4000,
  },
  {
    name: "Feb",
    "Active User": 3000,
  },
  {
    name: "Mar",
    "Active User": 5000,
  },
  {
    name: "Apr",
    "Active User": 4000,
  },
  {
    name: "May",
    "Active User": 3000,
  },
  {
    name: "Jun",
    "Active User": 2000,
  },
  {
    name: "Jul",
    "Active User": 4000,
  },
  {
    name: "Aug",
    "Active User": 3000,
  },
  {
    name: "Sep",
    "Active User": 4000,
  },
  {
    name: "Oct",
    "Active User": 1000,
  },
  {
    name: "Nov",
    "Active User": 4000,
  },
  {
    name: "Dec",
    "Active User": 3000,
  },
];

export const productData = [
  {
    name: "Jan",
    Sales: 4000,
  },
  {
    name: "Feb",
    Sales: 3000,
  },
  {
    name: "Mar",
    Sales: 5000,
  },
];

export const userRows = [
  {
    id: 1,
    username: "Aniket Yadav",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "aniket@gmail.com",
    status: "active",
    transaction: "Rs 1520.00",
  },
  {
    id: 2,
    username: "Kartik Tyagi",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "kartik@gmail.com",
    status: "active",
    transaction: "Rs 1660.00",
  },
  {
    id: 3,
    username: "Puneet Singh",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "puneet@gmail.com",
    status: "active",
    transaction: "Rs 9120.00",
  },
  {
    id: 4,
    username: "Dia Malhotra",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "dia@gmail.com",
    status: "active",
    transaction: "Rs 1980.00",
  },
  {
    id: 5,
    username: "Divyansh Verma",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "divyansh@gmail.com",
    status: "active",
    transaction: "Rs 2020.00",
  },
  {
    id: 6,
    username: "Aditya Kr. Singh",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "aditya@gmail.com",
    status: "active",
    transaction: "Rs 102.00",
  },
  {
    id: 7,
    username: "Yug Bhadana",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "bhadana@gmail.com",
    status: "active",
    transaction: "Rs 390.00",
  },
  {
    id: 8,
    username: "Jenny David",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jenny@gmail.com",
    status: "active",
    transaction: "Rs 910.00",
  },
  {
    id: 9,
    username: "Abhay Kaushik",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "abhay@gmail.com",
    status: "active",
    transaction: "Rs 789.00",
  },
  {
    id: 10,
    username: "Riya Singh",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "riya@gmail.com",
    status: "active",
    transaction: "Rs 290.00",
  },
];

export const productRows = [
  {
    id: 1,
    name: "Apple Airpods",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 22120.00",
  },
  {
    id: 2,
    name: "Macbook M1",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 87120.00",
  },
  {
    id: 3,
    name: "LG TV",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 89120.00",
  },
  {
    id: 4,
    name: "Iphone 14pro 1TB",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 125120.00",
  },
  {
    id: 5,
    name: "Oppo earbuds",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 3120.00",
  },
  {
    id: 6,
    name: "Apple Iphone Adapter",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 2000.00",
  },
  {
    id: 7,
    name: "SG Cricket Bat ",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 8120.00",
  },
  {
    id: 8,
    name: "Water Bottle",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 120.00",
  },
  {
    id: 9,
    name: "Petcare Perfume",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 620.00",
  },
  {
    id: 10,
    name: "Screen Protector for Ipad",
    img: "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "Rs 320.00",
  },
];
